@if (!!this.albumId) {
  @if (isStep2) {
    <app-form-album-teacher-step3> </app-form-album-teacher-step3>
  } @else {
    <app-form-album-teacher-step1></app-form-album-teacher-step1>
  }
} @else {
  @switch (creatorService.currentStep) {
    @case (2) {
      <app-form-album-teacher-step2> </app-form-album-teacher-step2>
    }
    @case (3) {
      <app-form-album-teacher-step3> </app-form-album-teacher-step3>
    }
    @default {
      <app-form-album-teacher-step1> </app-form-album-teacher-step1>
    }
  }
}
